import { http } from "@/service/http";

export const getHistoryMsg = (id) => {
  return http.post("/chat/getHistoryMsg", {
    group_id: id,
    page: 1,
    pagesize: 9999,
  });
};

export function getGroupList(data) {
  return http.post("/group/getGroupList", data);
}
export function getGroup(data) {
  return http.post("/group/getGroup", data);
}

export function saveGroup(data) {
  return http.post("/group/saveGroup", data);
}

export function delGroup(data) {
  return http.post("/group/delGroup", data);
}

export function delGroup_all() {
  return http.get("/group/delGroup_all");
}
